// Which Help Center topics belong to which screen (for the "Help for this
// page" button). Pure, so it is
// tested in plain Node (npm run test:help) and checked by scripts/help-check.mjs.

// Longest matching prefix wins. Every slug must be a real topic (help:check).
export const CONTEXT = [
    ['/dashboard', ['getting-started', 'roles-and-permissions']],
    ['/welcome', ['joining-portal']],
    ['/attendance', ['attendance']],
    ['/admin/attendance', ['team-attendance']],
    ['/leaves', ['leave', 'approving-requests']],
    ['/tools/expenses', ['expenses', 'approving-requests']],
    ['/time/approvals', ['approving-requests', 'time-tracking']],
    ['/time/reports', ['time-tracking']],
    ['/time', ['time-tracking']],
    ['/admin/time', ['time-tracking']],
    ['/my-salary', ['my-salary-and-payslips']],
    ['/tasks', ['my-tasks-and-documents']],
    ['/documents', ['my-tasks-and-documents']],
    ['/profile', ['sign-in-and-profile']],
    ['/bugs', ['report-a-problem']],
    ['/tools/pdf', ['pdf-and-document-tools']],
    ['/admin/payroll', ['payroll', 'my-salary-and-payslips']],
    ['/admin/holidays', ['holidays']],
    ['/admin/workflow', ['workflow-settings']],
    ['/admin/departments', ['departments']],
    ['/admin/settings', ['getting-started', 'roles-and-permissions']],
    ['/admin/users', ['user-management', 'users-and-roles']],
    ['/admin/config', ['system-config']],
    ['/admin/logs', ['system-config']],
    ['/admin/usage', ['usage-insights']],
    ['/admin/lifecycle', ['lifecycle-setup']],
    ['/admin/checklists', ['new-joiners-and-import', 'recording-exits', 'checklist-tasks', 'final-settlement']],
    ['/admin/documents', ['my-tasks-and-documents']],
    ['/settlements', ['final-settlement']],
    ['/platform/tenants', ['platform-owner']],
];

export const topicsForPath = (pathname) => {
    let best = null;
    for (const [prefix, slugs] of CONTEXT) {
        if ((pathname === prefix || pathname.startsWith(`${prefix}/`)) && (!best || prefix.length > best[0].length)) best = [prefix, slugs];
    }
    return best ? best[1] : [];
};

export const OPEN_HELP = 'open-help';
export const openHelp = () => window.dispatchEvent(new CustomEvent(OPEN_HELP));
